import { createContext, ReactNode, useContext, useState } from "react";
import {CustomsCommitteeFormFields} from '../model/schema';

const StateFormContext = createContext<{
    state: {
        customs: CustomsCommitteeFormFields | null;
    };
    setState: React.Dispatch<React.SetStateAction<{ customs: CustomsCommitteeFormFields | null }>>;
    resetStore: () => void;
}>({
    state: { customs: null },
    setState: () => {},
    resetStore: () => {},
});



export const StateFormProvider = ({children} : {children : ReactNode}) => {
   
    const [state , setState] = useState({
        customs : null
    });

    const resetStore = () => {
        setState({
            customs: null
        });
    };


    return <StateFormContext.Provider value={{
        state,
        setState,
        resetStore
    }}>{children}</StateFormContext.Provider>
}

export const useGovernmentPortalContext = () => useContext(StateFormContext)